import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

const service_types = {
  diy: 't(I want to create, schedule, and post my own email campaigns)',
  none: 't(I dont want to use the email campaign scheduling system)',
  optin: 't(Create email newsletters for me)',
  optout: 't(Dont create email newsletters for me)'
}

const EmailStrategyToken = ({ value }) => (
  <div className="token">
    <T text={ service_types[value] } />
  </div>
)

EmailStrategyToken.propTypes = {
  value: PropTypes.string
}

export default EmailStrategyToken
